import _styled from "styled-components";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import { RawButton } from "../../../Styled/Button";
import Icon, { StyledIcon } from "../../../Styled/Icon";
import { jsx as _jsx } from "react/jsx-runtime";
export const CollapseBtn = _ref => {
  let {
    isCollapsed,
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(RawButton, {
    title: isCollapsed ? t("story.expand") : t("story.collapse"),
    onClick: onClick,
    children: isCollapsed ? /*#__PURE__*/_jsx(StoryIcon, {
      styledWidth: "12px",
      glyph: Icon.GLYPHS.arrowDown,
      rotation: 180
    }) : /*#__PURE__*/_jsx(StoryIcon, {
      styledWidth: "12px",
      glyph: Icon.GLYPHS.arrowDown
    })
  });
};
export const ExitBtn = _ref2 => {
  let {
    onClick
  } = _ref2;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  return /*#__PURE__*/_jsx(RawButton, {
    onClick: onClick,
    title: t("story.exitBtn"),
    children: /*#__PURE__*/_jsx(_StyledStoryIcon, {
      styledWidth: "12px",
      glyph: Icon.GLYPHS.close,
      $_css: theme.colorPrimary
    })
  });
};
export const StoryIcon = styled(StyledIcon).attrs(() => ({
  fillColor: "white",
  opacity: 0.5
})).withConfig({
  displayName: "StoryButtons__StoryIcon",
  componentId: "sc-1u9ie30-0"
})(["&:hover{fill:", ";}"], p => p.theme.colorPrimary);
var _StyledStoryIcon = styled(StoryIcon).withConfig({
  displayName: "StoryButtons___StyledStoryIcon",
  componentId: "sc-1u9ie30-1"
})(["border-radius:50%;border:2px solid white;padding:2px;&:hover{border-color:", ";}"], p => p.$_css);